import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { buttonIds } from '@selfserve/react-utils';
import { StyledText } from '@selfserve/react-ui';

import {
  StyledLoader,
  StyledPriceContainer,
  StyledPricePair,
  PromoCode,
} from '../feature/summary';

export const StyledRemove = styled('span')`
  text-decoration: underline;
  cursor: pointer;
`;

interface Props {
  promoCodes: Array<PromoCode>;
  exceptionCodes?: Array<string>;
  isLoading: boolean;
  withLine?: boolean;
  handleRemovePromoCode: ((key: string) => () => void) | undefined;
}

export const SummaryPromoCodes = ({
  promoCodes,
  exceptionCodes,
  isLoading,
  withLine,
  handleRemovePromoCode,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {promoCodes.map(({ name, id, value, secondaryName }, i, arr) => (
        <StyledPriceContainer
          withLine={withLine && i === arr.length - 1}
          key={id}
        >
          <StyledPricePair>
            <StyledText as="div" className="summary-item-name" bold isSmall>
              {name || id}
            </StyledText>
            <StyledText as="div" bold isSmall>
              {isLoading ? <StyledLoader /> : <span className="">{value}</span>}
            </StyledText>
          </StyledPricePair>
          <StyledPricePair secondary>
            <StyledText as="div" className="summary-item-description">
              <span className="">
                <span>{secondaryName}</span>
                {handleRemovePromoCode && !exceptionCodes?.includes(id) && (
                  <>
                    {'\xa0\xa0•\xa0\xa0'}
                    <StyledRemove
                      className="summary-item-description-remove"
                      onClick={handleRemovePromoCode(id)}
                      id={buttonIds.removeCoupon}
                    >
                      {t('common.remove')}
                    </StyledRemove>
                  </>
                )}
              </span>
            </StyledText>
          </StyledPricePair>
        </StyledPriceContainer>
      ))}
    </>
  );
};
